import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, ViewChildren, QueryList, OnChanges, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialogClose, MatDialog } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import moment from 'moment';

import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { SchedulerService } from './scheduler.service';
import { SchedulerModel } from '../../core/models/scheduler.model';
import { PracticeModel } from '../../core/models/practice.model';
import { SchedulerFilterModel } from '../../core/models/scheduler-filter-model';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import { AppointmentComponent } from './appointment/appointment.component';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { ConfirmBoxComponent } from 'src/app/pages/confirm-box/confirm-box.component';
import { DayOfWeek, SchedulerViewType, ConfirmBoxAction, ConfirmeAppointmentTypes, ApiResponseCode, FileUploadType } from 'src/app/core/enums';
import { TerminologyItem } from 'src/app/core/interfaces/terminology-item';
import { ScopeService } from 'src/app/core/services/scope.service';
import { AppData } from 'src/app/app.data';
import { Meta } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { Utils } from 'src/app/core/utils';
import { FileUploadService } from 'src/app/core/services/file-upload.service';
//import { ThrowStmt } from '@angular/compiler';
import { UploadProgressComponent } from '../upload-progress/upload-progress.component';
import { PaymentService } from 'src/app/core/services/payment.service';
import { throwIfEmpty } from 'rxjs/operators';
import { JoinToPelecrdComponent } from '../join-to-pelecrd/join-to-pelecrd.component';
import { BitNotSetComponent } from '../bit-not-set/bit-not-set.component';
import { AllPaidOrPendingPaymentComponent } from '../all-paid-or-pending-payment/all-paid-or-pending-payment.component';
import { SendFormDialogComponent } from 'src/app/dialogs/send-form-dialog/send-form-dialog.component';
import { FormsService } from 'src/app/core/services/forms.service';
import { FileUpload2Service } from 'src/app/core/services/file-upload2.service';
import { CommonDialogComponent } from 'src/app/dialogs/common-dialog/common-dialog.component';
import { DepartmentModel } from 'src/app/core/models/department-model';


@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss']
})
export class SchedulerComponent implements OnInit, OnDestroy, AfterViewInit {

  public schedulers: SchedulerModel[] = [];
  public practices: PracticeModel[] = [];
  public deparmtnets: DepartmentModel[] = [];
  public terminoogy: any = {};
  public appointments: AppointmentModel[] = [];
  public firstDayOfWeek: DayOfWeek = DayOfWeek.Sunday;
  public startOfThisWeek: Date;
  public endOfThisWeek: Date;
  public form: UntypedFormGroup;
  public settings: Settings;
  public error: string;
  public filterChangesSubscription: Subscription;
  public schedulerSubscription: Subscription;
  public practiceSubscription: Subscription;


  public show_noDataLabel: boolean = false;
  public show_loadingSpinner: boolean = true;

  private nextClosestDateOutsideRange?: Date;
  private previousClosestDateOutsideRange?: Date;
  private loading: boolean;
  private viewType = SchedulerViewType.CustomWeek;

  fileUploadType: FileUploadType = FileUploadType.Undefined;



  @ViewChildren('weeklyEvents') weeklyAppointments: QueryList<AppointmentModel>;

  @ViewChild('file', { static: false }) file: ElementRef;
  @ViewChild('fileDocument') fileDocument: ElementRef<HTMLElement>;

  constructor(
    public appSettings: AppSettings,
    public fb: UntypedFormBuilder,
    public router: Router,
    public translate: TranslateService,
    private cookieService: CookieService,
    private adapter: DateAdapter<any>,
    private scdService: SchedulerService,
    private scopeService: ScopeService,
    private paymentService: PaymentService,
    private formService: FormsService,
    private dialog: MatDialog,
    private appData: AppData,
    private fileUpload: FileUploadService,
    private fileUpload2: FileUpload2Service,
    private meta: Meta) {

    // moment.locale("he");

    this.settings = appSettings.settings;

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  ngOnInit() {

    this.meta.updateTag({ name: 'Description', content: 'DoctorWeb for mobile scheduler page' });

    // init form
    this.form = this.fb.group({
      'start': [moment(), Validators.required],
      'scheduler': [null],
      'practice': [null]
    });
    // load previous form state
    this.loadState();
    // load scheduelr, practices
    this.loadUserScope();

    // register to changes to monitor the form state
    this.subscribeFormChanges();
  }

  ngOnDestroy() {
    // save form filter in session
    this.saveState();
  }



  onDateChange(event) {

    this.viewType = SchedulerViewType.CustomWeek;
    this.loadEvents();
  }



  ngAfterViewInit() {
    this.weeklyAppointments.changes.subscribe(t => {
      this.appointments_ngForRendred();
    });
  }

  appointments_ngForRendred() {
    this.scrollToChosenDate(this.f.start.value.toDate());
  }

  saveState() {
    sessionStorage.setItem('scheduler-state', JSON.stringify(this.form.value));
  }

  loadState() {
    // load last saved form data
    const state = sessionStorage.getItem('scheduler-state');
    if (state) {
      const obj = JSON.parse(state);
      this.f.start.setValue(moment(obj.start));
      this.f.scheduler.setValue(obj.scheduler);
      this.f.practice.setValue(obj.practice);
    }
  }

  subscribeFormChanges() {
    // this.unsubscribeFormChanges();

    // // recognize if form change and reload event
    // this.filterChangesSubscription = this.form.valueChanges.subscribe(val => {
    //   
    //   this.loadEvents();
    // });

    // this.f.start.valueChanges.subscribe(val => {

    // });


    // this.f.start.valueChanges.subscribe(val => {

    // });

    this.schedulerSubscription = this.f.scheduler.valueChanges.subscribe(val => {
      this.loadEvents();
    });
    this.practiceSubscription = this.f.practice.valueChanges.subscribe(val => {
      this.loadEvents();
    });
  }

  unsubscribeFormChanges() {
    // if (this.filterChangesSubscription && this.filterChangesSubscription.unsubscribe) {
    //   this.filterChangesSubscription.unsubscribe();
    // }

    if (this.schedulerSubscription && this.schedulerSubscription.unsubscribe) {
      this.schedulerSubscription.unsubscribe();
    }

    if (this.practiceSubscription && this.practiceSubscription.unsubscribe) {
      this.practiceSubscription.unsubscribe();
    }


  }

  // change the date to today when the today button click
  today() {
    this.adapter.setLocale(this.settings.locale);
    this.f.start.setValue(moment());

    this.viewType = SchedulerViewType.CustomDay; // pressing on the Days button should be loading only data for current day
    this.loadEvents();
  }

  navDay(val_navDay: number) {

    let loadNewWeek = true;
    let selectedDay: Date;

    // set flag for "newWeek" if +D\-D\datepicker selection is not in the current week, reload scheduler
    if (this.startOfThisWeek && this.endOfThisWeek) {
      selectedDay = moment(this.f.start.value).add(val_navDay, 'd').toDate();
      selectedDay = this.checkDate(selectedDay, val_navDay);
      loadNewWeek = selectedDay < this.startOfThisWeek || selectedDay > this.endOfThisWeek ? true : false;
    }

    if (loadNewWeek == false) {

      this.scrollToChosenDate(selectedDay);
      this.f.start.setValue(this.f.start.value.add(val_navDay, 'd'));


    } else {

      if (val_navDay < 0 && this.previousClosestDateOutsideRange) {
        this.f.start.setValue(moment(this.previousClosestDateOutsideRange));

      } else if (val_navDay > 0 && this.nextClosestDateOutsideRange) {
        this.f.start.setValue(moment(this.nextClosestDateOutsideRange));

      } else {
        this.f.start.setValue(this.f.start.value.add(val_navDay, 'd'));

      }
    }


    this.viewType = SchedulerViewType.CustomDay;
    this.loadEvents();

  }

  checkDate(date: Date, val_navDay: number): Date {

    if (!this.appointments || this.appointments.length == 0) {
      return date;
    }

    var date = new Date(date.setHours(0, 0, 0, 0)); // reset time
    var dates = this.appointments.map(x => new Date(x.Date.toDate().setHours(0, 0, 0, 0))); // reset time
    dates.sort((a, b) => a.getTime() - b.getTime());

    // if date exists in events return date
    var length = dates.filter(x => x.getTime() === date.getTime()).length;
    if (length > 0) {
      return date;

    } else if (val_navDay > 0) {
      // get next date
      let tmp = dates.filter(x => x.getTime() > date.getTime());
      if (tmp.length > 0) {
        return tmp[0];
      } else {
        return this.nextClosestDateOutsideRange || date;
      }

    } else if (val_navDay < 0) {
      // get previous date
      let tmp = dates.filter(x => x.getTime() < date.getTime());
      if (tmp.length > 0) {
        return tmp[tmp.length - 1];

      } else {
        return this.previousClosestDateOutsideRange || date;
      }
    }

    return date;

  }

  addDays(date, days) {
    var result = moment(date).toDate();
    result.setDate(result.getDate() + days);
    return result;
  }


  scrollToChosenDate(selecteDay: Date) {
    let int_selectedDay = selecteDay.getDate();
    let firstApptOfSelectedDate = this.appointments.filter(x => x.Start.get('date') === int_selectedDay)[0];

    if (firstApptOfSelectedDate) {
      // console.log(firstApptOfSelectedDate);
      let eventElement = document.getElementById('eventID_' + firstApptOfSelectedDate.EventID + '');
      // eventElement.scrollIntoView({ behavior: 'smooth', block:'center'});
      eventElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // TODO: Remove this when we're done
  get diagnostic() { return JSON.stringify(this.form.value); }

  loadUserScope() {

    this.scopeService.getUserScope().subscribe(result => {

      if (result.Code === 1) {
        const data = result.Data;
        this.schedulers = data.schedulers;
        this.practices = data.practices;
        this.terminoogy = data.terminoogy;
        this.firstDayOfWeek = data.firstDayOfWeek;
        // sessionStorage.setItem('userScope', JSON.stringify(result.Data));

        // for one scheduelr select the scheduler
        if (this.schedulers && this.schedulers.length === 1) {
          let scheduler = this.schedulers[0];
          this.f.scheduler.setValue(scheduler.ID);
        }


        // load appointment 
        this.loadEvents();
      } else {

        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {

      this.error = error;
    });
  }

  loadEvents() {

    if (this.loading) {
      return;
    }
    this.loading = true;

    const filterData = this.getFilter();
    this.appointments = [];
    this.show_loadingSpinner = true;

    this.scdService.loadEvents(filterData).subscribe({
      next: (result) => {
        this.loading = false;
        if (result.Code === 1) {
          this.appointments = result.Data.Appointments.map(item => new AppointmentModel(item));
  
          this.show_noDataLabel = this.appointments.length === 0;
          this.show_loadingSpinner = false;
          this.previousClosestDateOutsideRange = result.Data.PreviousClosestDateOutsideRange ? new Date(result.Data.PreviousClosestDateOutsideRange) : null;
          this.nextClosestDateOutsideRange = result.Data.NextClosestDateOutsideRange ? new Date(result.Data.NextClosestDateOutsideRange) : null;
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
      error: (error) => {
        this.loading = false;
        this.error = error;
      },
      complete: () => {
        console.info('complete');
      }
    });
    
  }



  getFilter(): SchedulerFilterModel {
    // all scheduler in scope
    let schedulerIDs = this.schedulers.map(x => x.ID);

    // filter by selected scheduler if scheduler selected
    if (this.f.scheduler.value) {
      schedulerIDs = [parseInt(this.f.scheduler.value, 10)];
    }



    // #8778 the date kind should be send as Unspecifed same as DRWEB
    let start = moment(this.f.start.value).startOf('day');
    let end = moment(start).add(7, 'days');


    const practice = this.f.practice.value || '';
    const department = '';
    const firstDayOfWeek = this.firstDayOfWeek;
    const schedulerType = '';


    // set first and last date of the currently selected week
    let tmp = moment(start).startOf('day'); // date without time
    this.startOfThisWeek = tmp.startOf('week').toDate();
    this.endOfThisWeek = tmp.endOf('week').toDate();

    if (this.viewType === SchedulerViewType.CustomDay) {
      tmp = moment(start);
      start = tmp;
      end = tmp;
    }

    // unspecied date
    //var dStart = new Date(start.format('YYYY-MM-DD HH:mm:ss.mmm'));
    //var dEnd = new Date(start.format('YYYY-MM-DD HH:mm:ss.mmm')); 

    return new SchedulerFilterModel(
      schedulerIDs,
      new Date(start.toString()),
      new Date(end.toString()),
      this.viewType,
      schedulerType,
      firstDayOfWeek,
      practice,
      department
    );
  }


  onConfirm(appointment) {

    appointment.Confirmed = ConfirmeAppointmentTypes.Confirmed;
    this.scdService.confirmAppointment(appointment).subscribe(result => {
      if (result.Code === 1) {
        // success
        // this.loadEvents();
        for (let index = 0; index < this.appointments.length; index++) {
          const element = this.appointments[index];
          if (element.EventID === appointment.appointment) {
            element.Confirmed = appointment.Confirmed;
          }
        }
      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {
      this.error = error;
    });
  }

  onDelete(appointment) {
    // this will be called by child event
    if (this.isDatePassed(appointment)) {
      // TODO: check permission in authService.calims
      alert('You cannot delete passed appointment');
      return;
    }

    if (!this.appData.cancelReasons || this.appData.cancelReasons.length === 0) {
      // reload cacnel reasons
      this.scdService.getCancelReasons().subscribe(result => {
        // the service populate 'appSettings.CancelReasons'
        if (result.Code === 1) {
          this.openDialog(appointment);
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
        error => {
          this.error = error;
        });
    } else {
      this.openDialog(appointment);
    }
  }




  openDialog(appointment: AppointmentModel) {
    // get locale message for dialog
    const title = this.translate.instant('CONFIRM.DELETE-APP-TITLE');
    const msg = this.translate.instant('CONFIRM.DELETE-APP-MSG', {
      name: appointment.Title,
      date: moment(appointment.Start).format('L'), // amDateFormat: 'L'
      time: moment(appointment.Start).format('LT') // amDateFormat: 'LT'
    });

    // open confiramation dialog to delete
    const dialogRef = this.dialog.open(ConfirmBoxComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        actionType: ConfirmBoxAction.DeleteAppointment,
        title: title,
        message: msg,
        cancelReasonID: appointment.CancelReasonID,
        cancelReason: appointment.CancelReason,
        alsoDeleteTreatments: false
      }
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // ok      
        appointment.CancelReason = result.cancelReason;
        appointment.CancelReasonID = result.cancelReasonID;
        appointment.AlsoDeleteTreatmentsFromCard = result.alsoDeleteTreatments || false;
        this.deleteAppointment(appointment);
      }
    });
  }

  deleteAppointment(appointment) {

    this.scdService.deleteEvent(appointment).subscribe(result => {
      // success - if here appointment deleted on server
      if (result.Code === 1) {
        // on success clear appointment from list
        const index = this.appointments.indexOf(appointment, 0);
        if (index > -1) {
          this.appointments.splice(index, 1);
        }
      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {
      this.error = error;
    });
  }



  isDatePassed(appointment) {
    return Utils.isDatePassed(appointment.Start);
  }

  // onSubmit(value) {
  //   if (this.form.valid) {
  //   }
  // }

  showDialogForEnableCameraPermission() {

    let msg = this.translate.instant(`MSG.ALLOW-PERMISSIONS-TO-CAMERA`);

    const dialogRef = this.dialog.open(CommonDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg,
        buttons: [
          {
            name: 'ok',
            text: this.translate.instant('COMMON.OK'),
            color: 'accent',
            width: '100%'
          }
        ]

      }
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult === 'ok') {

      }
    });


  }

  onCaptureImageClicked(appointment) {

    try {

      // check permission for camera
      // permissions.query  can only be found in Chrome 44 and later and Firefox 43 and later.
      if (Utils.isMobile()) {

        var browser = <any>navigator;
        browser.permissions.query({ name: 'camera' }).then(result => {

          console.log(result);
          if (result.state === 'denied') { //"denied" | "granted" | "prompt";
            // show message only when denied
            this.showDialogForEnableCameraPermission();
          }
          else {

            // trigger file upload
            this.fileUploadType = FileUploadType.Image;
            let el: HTMLElement = this.file.nativeElement;
            Utils.dispatchEvent(el, 'click');
          }
        })
      }
      else {
        // trigger file upload without checking permission - if granted the camera will open
        this.fileUploadType = FileUploadType.Image;
        let el: HTMLElement = this.file.nativeElement;
        Utils.dispatchEvent(el, 'click');
      }

    }
    catch (err) {
      // trigger file upload without checking permission - if granted the camera will open
      this.fileUploadType = FileUploadType.Image;
      let el: HTMLElement = this.file.nativeElement;
      Utils.dispatchEvent(el, 'click');
    }

  }

  onUploadDocumentClicked(appointment) {

    // trigger file upload
    this.fileUploadType = FileUploadType.Document;
    let el: HTMLElement = this.fileDocument.nativeElement;
    //el.click();
    Utils.dispatchEvent(el, 'click');
  }

  onUploadImage(event: any) {
    this.fileUploadType = FileUploadType.Image;
    this.onFileChange(event);
  }

  onUploadDocument(event: any) {
    this.fileUploadType = FileUploadType.Document;
    this.onFileChange(event);
  }

  onFileChange(event: any) {
    
    var customerID = this.appData.patient.ID;
    var departmentID = 0;
    var treatmentID = 0;
    var isProfileImage = this.appData.captureImageData.action == 'captureProfileImage';

    if (this.appData.appointment &&
      this.appData.appointment.Treatments &&
      this.appData.appointment.Treatments.length > 0 &&
      this.appData.appointment.Treatments[0].PriceListCodeDepartmentID > 0) {
      departmentID = this.appData.appointment.Treatments[0].PriceListCodeDepartmentID;
      treatmentID = this.appData.appointment.Treatments[0].ID;
    }


    const dialogRef = this.dialog.open(UploadProgressComponent, {
      width: '300px',
      direction: (this.settings.rtl ? 'rtl' : null),
      disableClose: true,
      data: {
        customerID: customerID,
        isProfileImage: isProfileImage,
        event: event,
        uploadType: this.fileUploadType,
        departmentID: departmentID,
        treatmentID: treatmentID
      }
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {
      if(this.fileUploadType == FileUploadType.Image){
        this.clearImageFiles(event);
      }
    });
  }

  clearImageFiles(event: any) {
    this.file.nativeElement.value = '';
    event.target.files = null;
  }

  onPaymentRequest(data: any) {
    //this.router.navigate(['/payment-request'], { queryParams: { eventid: data.appointment.EventID, provider: data.paymentRequest}});    

    const provider = data.paymentRequest;
    const eventID = data.appointment.EventID || 0;

    this.paymentService.getPrePaymentRequestDataForEvent(provider, eventID).subscribe(result => {

      if (result.Code === ApiResponseCode.Success) {

        if (result.Data.noTreatmentsToBePaid) {
          this.showDialogAllPaidOrPendingPayment();

        }
        else if (provider === 'pelecard' && !result.Data.hasPelecard) {
          this.showDialogJoinToPelecard();
        }
        else if (provider === 'bit' && !result.Data.hasBit) {
          this.showDialogBitNotSet();
        }
        else {
          this.appData.prePaymentRequestData = result.Data;
          this.router.navigate(['/payment-request']);
        }


      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {
      this.error = error;
    });
  }

  showDialogJoinToPelecard() {

    // open a dialog with details to join pelecard
    const dialogRef = this.dialog.open(JoinToPelecrdComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {}
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // nothing todo here             
      }
    });
  }

  showDialogBitNotSet() {
    // open a dialog with details to join pelecard
    const dialogRef = this.dialog.open(BitNotSetComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {}
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // nothing todo here             
      }
    });
  }

  showDialogAllPaidOrPendingPayment() {
    // open a dialog with details to join pelecard
    const dialogRef = this.dialog.open(AllPaidOrPendingPaymentComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {}
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // nothing todo here             
      }
    });
  }

  onSendOrFillForm(data: any) {

    // open dialog
    const dialogRef = this.dialog.open(SendFormDialogComponent, {
      width: '380px',
      panelClass: 'custom-panel-dialog',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: data
    });


    dialogRef.afterClosed().subscribe(resultData => {

      if (resultData) {
        if (resultData.result === FormsService.SEND_TO_CUSTOMER) {
          this.formService.data = resultData;
          this.router.navigate(['/select-form']);
        }
        else if (resultData.result === FormsService.FILL_BY_THERAPIST) {
          this.formService.data = resultData;
          this.router.navigate(['/select-form']);
        }
        else {
          this.formService.data = {};
        }
      }
      else {
        this.formService.data = {};
      }
    });
  }
}
